<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header d-xl-flex justify-content-between">
              <h3>Extrusión</h3>
              <div>
                <base-button
                  @click="openOrderModal"
                  icon="fa fa-plus"
                  size="sm"
                >
                  Nueva Orden de Producción
                </base-button>
              </div>
            </div>
            <ag-grid-vue
              v-bind="agPOrders"
              ref="agPOrders"
              @grid-ready="onGridReady"
              @cell-clicked="onCellClicked"
              style="height: 70vh;"
              class="ag-theme-alpine mb-4"
            />
          </div>
        </div>
      </div>
    </div>

    <side-panel :open.sync="sidePanel" backdrop width="530px">
      <ComponentForm
        :compData="compData"
        :components="components"
        :warehouses="warehouses"
        @addNew="onAddNew"
        @saveChanges="onSaveChanges"
        @remove="onRemove"
        @close="sidePanel = false; compData = null;"
        />
    </side-panel>

    <modal
      :show.sync="modalPO"
      modal-classes="modal-dialog-centered custom-modal-width"
      @close="onClose"
    >
      <div @click="modalPO = false" class="position-absolute top-0 right-0 p-2" style="cursor: pointer; z-index: 2;">
        <i class="fa fa-times close-button p-2"></i>
      </div>
      <div class="">
        <ProductionOrder
          ref="orderModal"
          v-if="modalPO"
          @success="resetTable()"
          @close="modalPO = false"
          @openComponent="onOpenComponent"
          :documentNumber="documentNumber"
          :components="components"
          :warehouses="warehouses"
        />
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import { AgGridVue } from "ag-grid-vue";
import ProductionOrder from "./ProductionOrder.vue";
import SidePanel from "@/components/SidePanel.vue";
import ComponentForm from "./ComponentForm.vue";
import axios from "axios";
import Formats from "@/mixins/Formats";
import AgBadge from "@/components/AgGrid/AgBadge.vue";
import poStatus from "@/data/poStatus.json";
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import AgGrid from "@/mixins/AgGrid.js";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
export default {
  mixins: [Formats, AgGrid],
  components: {
    AgGridVue,
    ProductionOrder,
    SidePanel,
    ComponentForm,
    AgBadge,
    BaseLoader,
    EmptySection,
    agDateInput: FilterDate,
  },
  data() {
    return {
      modalPO: false,
      sidePanel: false,
      compData: null, 
      documentNumber: null,
      components: null,
      warehouses: null,
      agPOrders: {
        columnDefs: [
          {
            headerName: "# Orden",
            field: "DocNum",
            cellClass: (params) => {
              let classes = ["font-weight-bold"]; 
              if(params.data.Status !== 'L'){
                classes.push('text-clickable text-blue ');
              }
              return classes;
            },
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Código",
            field: "ItemCode",
            width: 350,
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Descripción",
            field: "ProdName",
            width: 400,
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Almacén",
            field: "Warehouse",
            filter: "agSetColumnFilter",
            filterParams: {
              values:  ['VAL-EXT','EXT-06','EXT-01'],
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
          },
          {
            headerName: "Estatus",
            field: "Status",
            filter: "agSetColumnFilter",
            filterParams: {
              values: poStatus.map((x) => x.id2),
              defaultToNothingSelected: true,
              valueFormatter: ({value}) => poStatus.find((x) => x.id2 === value).name,
              applyMiniFilterWhileTyping: true,
            },
            cellRendererSelector: ({value}) => {
              const status = poStatus.find((x) => x.id2 === value);
              return {
                component: "AgBadge",
                params: {
                  text: status.name,
                  color: status.color,
                },
              };
            },
          },
          {
            headerName: "Cantidad",
            field: "PlannedQty",
            type: "numericColumn",
            filter: "agNumberColumnFilter",
            valueFormatter: (params) => this.numberFormat(params.value),
          },
          {
            headerName: "Pedido",
            field: "CreateDate",
            filter: "agDateColumnFilter",
            valueFormatter: ({value}) => this.dateFormat(value),
          },
          {
            headerName: "Inicio",
            field: "StartDate",
            filter: "agDateColumnFilter",
            valueFormatter: ({value}) => this.dateFormat(value),
          },
          {
            headerName: "Vencimiento",
            field: "DueDate",
            filter: "agDateColumnFilter",
            valueFormatter: ({value}) => this.dateFormat(value),
          },
        ],
        defaultColDef: {
          menuTabs: ["filterMenuTab"],
          // suppressHeaderMenuButton: true,
          cellDataType: false,
          floatingFilter: true,
          suppressFloatingFilterButton: true,
        },
        autoSizeStrategy: {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        },
        rowModelType: "serverSide",
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        noRowsOverlayComponent: "EmptySection",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        alwaysShowVerticalScroll: true,
        localeText: AG_GRID_LOCALE_ES,
      },
    };
  },
  created() {
    this.BASE_URL = process.env.VUE_APP_BASE_URL;
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
  },
  methods: {
    onGridReady({api}) {
      api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
    },
    getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;

          //SELECT
          const select = `"DocNum", "ItemCode", "Status", "PlannedQty", "DueDate", "Warehouse", "CreateDate", "StartDate", "ProdName"`;

          //FILTERS
          let filters = `WHERE "Project" = 'EXT'`;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map((condition) => {
                  return this.formatCondition(condition, key);
                }
              );
              const toPush = "(" + conditionsArray.join(" " + filterModel[key].operator + " ") + ")";
              acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if(condition){
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if(all.length){
              filters += " AND " + all.join(" AND ");
            }
          }

          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;

          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${sortModel[0].colId}" ${sortModel[0].sort.toUpperCase()}`;
            if(sortModel[0].colId !== "DocNum"){
              sorting += `, "DocNum" DESC`;
            }
          } else {
            sorting = `ORDER BY "DocNum" DESC`;
          }

          //JSON PAYLOADS
          const rowDataJson = {
            query: `
              SELECT ${select}
              FROM ${this.DATABASE}."OWOR"
              ${filters}
              ${sorting}
              ${pagination}
            `
          };
          const totalsJson = {
            query: `
              SELECT COUNT(*) AS "rowCount"
              FROM ${this.DATABASE}."OWOR"
              ${filters}
            `
          };

          // console.log("🟦rowDataJson", rowDataJson.query);
          // console.log("🟦totalsJson", totalsJson.query);
          
          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                console.log("🟪 DATA", rowDataRes.data);
                // console.log("🟪 TOTALS", totalsRes.data);
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
                
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },
    onCellClicked(params) {
      if (params.colDef.field === "DocNum" && params.data.Status !== 'L') {
        this.openPO(params.value);
      }
    },
    openPO(docNum) {
      this.documentNumber = docNum;
      this.modalPO = true;
      this.loadAllComponents();
      this.loadWarehouses();
    },
    onOpenComponent(params) {
      this.sidePanel = true;
      this.compData = params;
    },
    openOrderModal() {
      this.documentNumber = null;
      this.modalPO = true;
      this.loadAllComponents();
      this.loadWarehouses();
    },
    loadAllComponents() {
      if (!this.components) {
        axios
          .get(`/api/items/list/components`)
          .then((res) => {
            this.components = res.data.map(({ ItemCode, ItemName }) => ({
              ItemCode,
              ItemName,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    loadWarehouses() {
      if (!this.warehouses) {
        axios
          .get(`/api/warehouses`)
          .then((result) => {
            this.warehouses = result.data.value
              .filter(({ WarehouseCode }) => ['VAL-EXT','EXT-06','EXT-01'].includes(WarehouseCode))
              .map(({ WarehouseCode }) => WarehouseCode
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    onAddNew(data) {
      this.$refs.orderModal.addNewComponent(data);
      this.sidePanel = false;
    },
    onSaveChanges(data) {
      this.$refs.orderModal.saveChanges(data);
      this.sidePanel = false;
    },
    onRemove(itemCode) {
      this.$refs.orderModal.removeComponent(itemCode);
      this.sidePanel = false;
    },
    resetTable(){
      this.$refs.agPOrders.api.setFilterModel(null);
      this.$refs.agPOrders.api.resetColumnState();
      this.$refs.agPOrders.api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
      this.$refs.agPOrders.api.sizeColumnsToFit();
    },
    onClose() {
      this.compData = null;
      this.documentNumber = null;
    },
  },
};
</script>

<style lang="scss">
.custom-modal-width {
  max-width: 1400px;
}
.text-clickable{
  cursor: pointer;
}
.text-clickable:hover {
  color: #4a5fda;
  background-color: #e2e8f0;
}
</style>
